import { createTheme } from "@mui/material";
const theme = createTheme({
  palette: {
    primary: {
      main: "#1a59cb",
    },
    secondary: {
      main: "#1a59cb",
    },
    info: {
      main: "#4E148C",
    },
    success: {
      main: "#4E148C",
    },
    error: {
      main: "#4E148C",
    },
    warning: {
      main: "#4E148C",
    },
  },
});
export default theme;
